import { render, staticRenderFns } from "./PurchaseViewItem.vue?vue&type=template&id=7f357b38&scoped=true&"
import script from "./PurchaseViewItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseViewItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseViewItem.vue?vue&type=style&index=0&id=7f357b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f357b38",
  null
  
)

export default component.exports